<div class="page-container" [class.loading]="isLoading">
    <app-header title="reporting.reports.payrollDigest.title" [back]="true"
        ><ui-button class="buttons" (click)="onExport()" type="primary">{{
            'export' | translate
        }}</ui-button></app-header
    >

    <mat-chip-listbox [value]="showArchived ? 'archived' : 'active'" (change)="toggleArchived()">
        <mat-chip-option value="active">
            {{ 'reporting.reports.active' | translate }}
        </mat-chip-option>
        <mat-chip-option value="archived">
            {{ 'reporting.reports.archived' | translate }}
        </mat-chip-option>
    </mat-chip-listbox>

    <!--
        The first ngIf checks if the observer has emitted any values.
        The second one checks the length of the current digest array.
    -->
    <ng-container *ngIf="payrollDigest$ | async as payrollDigest">
        <ng-container *ngIf="payrollDigest.length > 0; else empty">
            <ui-card *ngFor="let event of payrollDigest">
                <ui-button *ngIf="!showArchived" type="primary" style="float: right" (click)="archive(event.id)"
                    >{{ 'reporting.reports.archive' | translate }}
                </ui-button>
                <ui-button *ngIf="showArchived" type="primary" style="float: right" (click)="unarchive(event.id)"
                    >{{ 'reporting.reports.unarchive' | translate }}
                </ui-button>

                <!-- Descriptions -->
                <h3 style="margin-top: 0">{{ event.title }} - {{ event.date | appDate: 'mediumDate' }}</h3>
                <p>{{ event.message }}</p>
            </ui-card>

            <div class="loadable" [class.loading]="isLoadingMore"></div>
        </ng-container>
        <ng-template #empty>
            <ui-card>
                <i class="fa fa-info-circle"></i> {{ 'reporting.reports.payrollDigest.noChangesFound' | translate }}
            </ui-card>
        </ng-template>
    </ng-container>
</div>
